import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5a8ea473"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "selected" }, "...", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret" }, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "menudf" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = {
  key: 0,
  class: "flex grow w100 align-center"
}
const _hoisted_8 = { class: "flex col w100 g10" }
const _hoisted_9 = { class: "flex align-start grow" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"filter":"invert(0.3)"},
  src: "/ico/search.svg"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_12 = {
  key: 0,
  style: {"white-space":"nowrap"}
}
const _hoisted_13 = {
  key: 1,
  style: {"white-space":"nowrap"}
}
const _hoisted_14 = { class: "flex col g0" }
const _hoisted_15 = { style: {"white-space":"nowrap","line-height":"19px"} }
const _hoisted_16 = {
  key: 0,
  class: "text-muted",
  style: {"white-space":"nowrap","line-height":"13px","font-size":"13px"}
}
const _hoisted_17 = {
  key: 0,
  class: "add-btn"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-select" }, "Aucune selection", -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_SeCheckBox = _resolveComponent("SeCheckBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelectClick())),
      class: "select"
    }, _hoisted_4),
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.search)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("textarea", {
                    oninput: "this.value = this.value.replace(/\\n/g,'')",
                    ref: "searchInput",
                    style: {"resize":"none","width":"100%","height":"19px","overflow":"hidden"},
                    onKeyup: _cache[1] || (_cache[1] = (e) => _ctx.onSearchChange(e.target.value)),
                    class: "search-input",
                    type: "text"
                  }, null, 544)
                ]),
                _hoisted_11
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (_ctx.selectAll)
            ? (_openBlock(), _createBlock(_component_SeFadeButton, {
                key: 0,
                onClick: [
                  _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                  _ctx.toggleSelectAll
                ]
              }, {
                default: _withCtx(() => [
                  (_ctx.items.length != _ctx.selectedIndexes.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Selectionner tout"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, "Deselectionner tout"))
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("li", { key: item }, [
          _createVNode(_component_SeCheckBox, {
            readonly: true,
            checked: _ctx.selectedIndexes.includes(_ctx.items.indexOf(item)),
            onClick: ($event: any) => (_ctx.optionClick(item))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getLabel(item)), 1),
                (_ctx.getDescription(item) != null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.getDescription(item)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["checked", "onClick"])
        ]))
      }), 128)),
      (_ctx.addCallback != null)
        ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
            _createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = () => _ctx.addCallback()),
              class: "bold"
            }, "+ " + _toDisplayString(_ctx.Lang.getI18N("add")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.items.length == 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_18, _hoisted_20))
        : _createCommentVNode("", true)
    ])
  ]))
}